import CarouselIcon from './CarouselIcon';
import type { CarouselIconProps } from './CarouselIcon';

export type { CarouselIconProps };
export default CarouselIcon;
